
// vue
import { defineComponent, reactive } from 'vue';

export default defineComponent({
  props: {
    fontSize: {
      type: String,
      require: false,
      default: '',
    },
  },
  setup(props) {
    const style = reactive<string[]>([]);
    if (props.fontSize !== '') {
      style.push(`font-size: ${props.fontSize}px`);
    }

    return {
      style,
    };
  },
});
